<template>
  <div class="ui container">
    <div v-if="isHost">
      <div class="ui segment" v-if="infoText">
        <h1 class="ui header">{{ infoText }}</h1>
      </div>
      <div
        class="ui right labeled icon orange massive fluid button"
        :class="{ loading, disabled: loading }"
        id="start-player-turn"
        @click.once="startPlaying"
      >
        <i class="play icon"></i> Start de klok [ENTER]
      </div>
      <div class="ui hidden divider"></div>
    </div>

    <youtube
      :video-id="youtubeId"
      :player-vars="{
        start,
        end,
        autoplay: !isHost ? 1 : 0,
        showinfo: isHost ? 1 : 0,
        autohide: !isHost ? 1 : 0
      }"
    >
    </youtube>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ROUNDS } from '@/config';
import Youtube from './youtube';
import Mousetrap from 'mousetrap';

export default {
  name: 'play-video',
  components: { Youtube },
  props: ['youtubeId', 'start', 'end', 'infoText'],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters(['isHost'])
  },
  created() {
    this.addKeyboardShortcuts();
  },
  methods: {
    startPlaying() {
      this.loading = true;
      this.$store
        .dispatch(
          `${ROUNDS[this.$store.state.game.currentRound].slug}/startPlaying`
        )
        .then(() => {
          this.$store.dispatch('syncGame');
          this.loading = false;
        });
    },
    addKeyboardShortcuts() {
      Mousetrap.bind('enter', () => {
        const startButton = document.querySelector('#start-player-turn');
        if (startButton) startButton.click();
        return false;
      });
    }
  }
};
</script>

<style scoped></style>
